import React from "react";
import PropTypes from "prop-types";

import Badge from "../Badge";

import styles from "./DropdownSubtitleItem.css";

const DropdownSubtitleItem = ({ value: { badge, subtitle, title } }) => (
  <div className={styles.subtitleItem}>
    <div className={styles.title}>
      {badge && <Badge>{badge}</Badge>}
      <div>{title}</div>
    </div>
    <div className={styles.subtitle}>{subtitle}</div>
  </div>
);

DropdownSubtitleItem.propTypes = {
  value: PropTypes.shape({
    badge: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
  }),
};

export default DropdownSubtitleItem;
